import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LoadingSvg from "@/assets/icons/loading.svg";

export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    size: { default: "60px" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "loading-spinner text-center",
    style: _normalizeStyle(`--size: ${__props.size}`)
  }, [
    _createVNode(_unref(LoadingSvg), { class: "svg" })
  ], 4))
}
}

})